import { render, staticRenderFns } from "./HomeGetStarted.vue?vue&type=template&id=6508cd02&scoped=true&"
import script from "./HomeGetStarted.vue?vue&type=script&lang=ts&"
export * from "./HomeGetStarted.vue?vue&type=script&lang=ts&"
import style0 from "./HomeGetStarted.vue?vue&type=style&index=0&id=6508cd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508cd02",
  null
  
)

export default component.exports